export const ERROR_CODE = {
  INIT_FAIL: 'INIT_FAIL',
  GET_COIN_DETAIL_FAIL: 'GET_COIN_DETAIL_FAIL',
  CREATE_COIN_ORDER_FAIL: 'CREATE_COIN_ORDER_FAIL',
  GET_PAYMENT_DETAIL_FAIL: 'GET_PAYMENT_DETAIL_FAIL',
  CREATE_THIRDPARTY_PAYMENT_FAIL: 'CREATE_THIRDPARTY_PAYMENT_FAIL'
}
